function openSidebar (sidebarToggleBurger, sidebar) {
  sidebar.classList.add('mtt-archive-sidebar--open')
  sidebarToggleBurger.classList.add('open')
}

function closeSidebar (sidebarToggleBurger, sidebar) {
  sidebar.classList.remove('mtt-archive-sidebar--open')
  sidebarToggleBurger.classList.remove('open')
}

function toggleSidebar (sidebarToggleBurger, sidebar) {
  sidebar.classList.contains('mtt-archive-sidebar--open')
    ? closeSidebar(sidebarToggleBurger, sidebar)
    : openSidebar(sidebarToggleBurger, sidebar)
}

export default function sidebarMenu (archive) {
  const sidebar = archive.querySelector('.mtt-archive-sidebar')
  const sidebarToggle = archive.querySelector('.mtt-archive-sidebar-toggle')

  if (sidebar !== null && sidebarToggle !== null) {
    const sidebarToggleBurger = sidebarToggle.querySelector('.sidebar-toggle')
    const sidebarMenuToggle = sidebar.querySelector('.sidebar-toggle')
    const sidebarButtons = sidebar.querySelectorAll('[data-archive-button]:not(.has-children)')

    if (sidebarMenuToggle !== null) {
      sidebarToggle.addEventListener('click', () => toggleSidebar(sidebarToggleBurger, sidebar))
      sidebarMenuToggle.addEventListener('click', () => closeSidebar(sidebarToggleBurger, sidebar))
      sidebarButtons.forEach(button => button.addEventListener('click', () => closeSidebar(sidebarToggleBurger, sidebar)))
    }
  }
}
